<template>
  <div class="article-card-skeleton" :class="cardClasses">
    <div class="image skeleton" />
    <div class="body">
      <Skeleton
        v-for="index in props.theme === 'horizontal' ? 4 : 3"
        :key="`title-skeleton-${index}`"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import Skeleton from '~/components/components/skeleton/Skeleton.vue';

// --- props ---
const props = defineProps({
  theme: {
    type: String,
    validator: (value: string) => ['vertical', 'horizontal'].includes(value),
    default: 'vertical',
  },
});

const cardClasses = computed((): object => {
  return {
    [`theme-${props.theme}`]: true,
  };
});
</script>

<style lang="scss" scoped>
.article-card-skeleton {
  position: relative;
  height: 100%;
  border-radius: $border-radius-l;
  display: flex;
  flex-direction: column;
  background-size: cover;
  color: $color-white;
  overflow: hidden;
  justify-content: space-between;
  background-color: rgba($color-potato-10, 0.3);

  > .image {
    border-radius: $border-radius-l;
    z-index: 2;
    width: 100%;
    height: 200px;
    min-height: 200px;
    overflow: hidden;
  }

  > .body {
    height: 100%;
    padding: 24px;
    z-index: 1;
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    gap: 8px;
  }

  > .body > .skeleton {
    height: 16px;
    width: 100%;
    border-radius: $border-radius-l;

    &:first-of-type {
      width: 60px;
    }

    &:nth-of-type(2) {
      width: calc(100% - 60px - 8px);
    }

    &:nth-of-type(3) {
      width: 80%;
    }

    &:nth-of-type(4) {
      width: 50%;
    }
  }

  &.theme {
    &-horizontal {
      flex-direction: row-reverse;

      > .body {
        width: calc(100% - 172px);
        margin-top: 0;
        padding: 24px 52px 24px 24px;
        border-radius: $border-radius-l 0 0 $border-radius-l;

        @include mobile {
          width: calc(100% - 100px);
        }
      }

      > .image {
        width: 197px;
        height: 172px;
        min-height: auto;
        border-radius: 32px;
        margin-left: -32px;

        @include mobile {
          width: 132px;
          height: 144px;
        }
      }
    }
  }
}
</style>
